export const DRAWER_PRODUCT_LIST = 'product-list';
export const DRAWER_PRODUCT_DETAIL = 'product-detail';
export const DRAWER_SHOPPING_CART = 'shopping-cart';
export const DRAWER_CHECKOUT = 'checkout';
export const DRAWER_ORDER_CONFIRMATION = 'order-confirmation';


export const DRAWER_CLOSE = '';